const LoanClosingTestIdsScope = {
  CLOSING_COMPANY_FORM: 'closing-company-form',
  FUNDING_INFORMATION_FORM: 'funding-information-form',
  TITLE_HOLDER_INFO_FORM: 'title-holder-info-form',
};

export const LoanClosingTestIds = {
  // ClosingCompanyForm
  CLOSING_COMPANY_FORM_CANCEL_BUTTON: `${LoanClosingTestIdsScope.CLOSING_COMPANY_FORM}.cancel-button`,
  CLOSING_COMPANY_FORM_SUBMIT_BUTTON: `${LoanClosingTestIdsScope.CLOSING_COMPANY_FORM}.submit-button`,

  // ClosingCompanyForm.config
  CLOSING_COMPANY_FORM_CHANGE_LOCATION_BUTTON: `${LoanClosingTestIdsScope.CLOSING_COMPANY_FORM}.change-location-button`,

  // TitleHolderInfoPersonForm
  TITLE_HOLDER_INFO_PERSON_FORM_SUBMIT_BUTTON: 'title-holder-info-person-form.submit-button',

  // Config file fields
  FUNDING_INFORMATION_FORM_WIRE_POSTED_DATE_INPUT: `${LoanClosingTestIdsScope.FUNDING_INFORMATION_FORM}.wire-posted-date-input`,
  FUNDING_INFORMATION_FORM_FUNDING_ORDERED_INPUT: `${LoanClosingTestIdsScope.FUNDING_INFORMATION_FORM}.funding-ordered-input`,
  TITLE_HOLDER_INFO_FORM_FIRST_NAME_INPUT: `${LoanClosingTestIdsScope.TITLE_HOLDER_INFO_FORM}.first-name-input`,
  TITLE_HOLDER_INFO_FORM_MIDDLE_NAME_INPUT: `${LoanClosingTestIdsScope.TITLE_HOLDER_INFO_FORM}.middle-name-input`,
  TITLE_HOLDER_INFO_FORM_LAST_NAME_INPUT: `${LoanClosingTestIdsScope.TITLE_HOLDER_INFO_FORM}.last-name-input`,
  TITLE_HOLDER_INFO_FORM_SUFFIX_SELECT: `${LoanClosingTestIdsScope.TITLE_HOLDER_INFO_FORM}.suffix-select`,
  TITLE_HOLDER_INFO_FORM_EMAIL_INPUT: `${LoanClosingTestIdsScope.TITLE_HOLDER_INFO_FORM}.email-input`,
  TITLE_HOLDER_INFO_FORM_CELL_PHONE_NUMBER_INPUT: `${LoanClosingTestIdsScope.TITLE_HOLDER_INFO_FORM}.cell-phone-number-input`,
  TITLE_HOLDER_INFO_FORM_COMPANY_NAME_INPUT: `${LoanClosingTestIdsScope.TITLE_HOLDER_INFO_FORM}.company-name-input`,
  TITLE_HOLDER_INFO_FORM_MANNER_HELD_SELECT: `${LoanClosingTestIdsScope.TITLE_HOLDER_INFO_FORM}.manner-held-select`,
  TITLE_HOLDER_INFO_FORM_VESTING_DESCRIPTION_INPUT: `${LoanClosingTestIdsScope.TITLE_HOLDER_INFO_FORM}.vesting-description-input`,
  TITLE_HOLDER_INFO_FORM_BORROWER_VESTING_SELECT: `${LoanClosingTestIdsScope.TITLE_HOLDER_INFO_FORM}.borrower-vesting-select`,
};
